export const maskCEP = (value: string): string => {
  // Remove tudo que não for número e limita a 8 caracteres
  const digits = value.replace(/\D/g, '').slice(0, 8);
  
  // Aplica a máscara XXXXX-XXX progressivamente conforme a digitação
  return digits.replace(/^(\d{5})(\d)/, '$1-$2');
};

export const maskPhone = (value: string): string => {
  // Remove tudo que não for número e limita a 11 caracteres no máximo
  const digits = value.replace(/\D/g, '').slice(0, 11);

  // Aplica a formatação progressivamente de acordo com o tamanho
  if (digits.length <= 2) {
    return digits.replace(/^(\d{1,2})/, '($1');
  } else if (digits.length <= 6) {
    return digits.replace(/^(\d{2})(\d{1,4})/, '($1) $2');
  } else if (digits.length <= 10) { 
    // Formato fixo: (XX) XXXX-XXXX
    return digits.replace(/^(\d{2})(\d{4})(\d{1,4})/, '($1) $2-$3');
  } else { 
    // Formato celular (11 dígitos): (XX) 9XXXX-XXXX
    return digits.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
};

export const onlyNumbers = (value: string): string => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};

export const capitalizeName = (name: string): string => {
  if (!name) return '';
  
  return name
    .toLowerCase()
    .split(' ')
    .filter(word => word.length > 0)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
